import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

// components
import {
  ExportLinkCSV,
  MainLayout,
  BlackWhiteRoundedButton,
} from "components/index";

// containers
import { FilteredList } from "containers";

// utils
import translations from "utils/translations";

import { filtersList } from "./ProfessionalsList.filters";
import useHeader from "./ProfessionalsList.header";
import { useRegistryDataListFetch } from "hooks";
import { HeaderContainer } from "./ProfessionalsList.styles";

import { REGISTRY_PROFESSIONALS_CREATE } from "constants/routes";

function ProfessionalsList() {
  const [header] = useHeader();
  const intl = useIntl();
  const i18n = translations.components.RegistryLists(intl);
  const navigate = useNavigate();

  const renderHeaderAction = () => {
    return (
      <>
        <HeaderContainer>
          <BlackWhiteRoundedButton
            onClick={() => navigate(REGISTRY_PROFESSIONALS_CREATE)}
            label={i18n.employees.createbtnText}
          />
          <ExportLinkCSV /> {/*TODO: add data for export*/}
        </HeaderContainer>
      </>
    );
  };

  return (
    <MainLayout>
      <FilteredList
        useCustomFetch={useRegistryDataListFetch}
        i18n={i18n.professionals}
        i18nErrors={i18n.errors}
        header={header}
        headerAction={renderHeaderAction()}
        filtersList={filtersList}
        queryUserTypeParams={""}
      />
    </MainLayout>
  );
}

export { ProfessionalsList };
